module.exports = __webpack_public_path__ + "static/media/mobily.d2cba45c.svg";